import React, { useEffect, useState } from 'react'
import { LI } from '../../../AbstractElements';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';
import { Href } from '../../../Utils/Constants';
import { applyColorMode, readColorMode, saveColorMode } from '../../../Utils/colorMode';

export default function MoonLight() {
    const [darkMode, setDarkMode] = useState(() => readColorMode() === 'dark');
    useEffect(() => { applyColorMode(darkMode ? 'dark' : 'light'); }, [darkMode]);

    const darkModeHandler = (event: React.MouseEvent) => {
        event.preventDefault();
        const nextDarkMode = !document.body.classList.contains('dark-only');
        const mode = nextDarkMode ? 'dark' : 'light';
        saveColorMode(mode);
        applyColorMode(mode);
        setDarkMode(nextDarkMode);
    };
    return (
        <LI>
            <a className={`dark-mode ${darkMode ? 'active' : ''}`} onClick={darkModeHandler} href={Href} aria-label="Cambia tema" aria-pressed={darkMode}>
                <SvgIcon iconId='moondark' />
            </a>
        </LI>
    )
}